module.exports = __webpack_public_path__ + "img/elite_tenant_star.631eb9dc.svg";